@if (usagePoints) {
  <div>
    <h2 class="page-title col-12">Sélectionnez votre N°PDL Électricité</h2>
    @for (usagePoint of usagePoints; track usagePoint) {
      <div class="mb-3">
        <div class="card bordered cursor-pointer" (click)="onClickUsagePoint(usagePoint)">
          <div class="card-body">
            <h5 class="card-title">N°PDL : {{ usagePoint.usagePointId }}</h5>
            <p class="card-text">
              {{ usagePoint.address.toString() }}
            </p>
          </div>
        </div>
      </div>
    }
  </div>
}
@if (gazparUsagePoints) {
  <div>
    <h2 class="page-title col-12">Sélectionnez votre N°PCE Gaz</h2>
    @for (usagePoint of gazparUsagePoints; track usagePoint) {
      <div class="mb-3">
        <div class="card bordered cursor-pointer" (click)="onClickGazparUsagePoint(usagePoint)">
          <div class="card-body">
            <h5 class="card-title">N°PCE : {{ usagePoint.pce.idPce }}</h5>
            <p class="card-text">
              {{ null !== usagePoint.donneesTechniques && null !== usagePoint.donneesTechniques.situationCompteur ? usagePoint.donneesTechniques.situationCompteur.toString() : '' }}
            </p>
          </div>
        </div>
      </div>
    }
  </div>
}
